import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface RequireResellerProps {
  children: React.ReactNode;
}

export default function RequireReseller({ children }: RequireResellerProps) {
  const { isAuthenticated, isReseller } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (!isReseller) {
    return <Navigate to="/my" replace />;
  }
  return <>{children}</>;
}
